import React, { useState } from "react";
import submit from "submit-form";
import {
  getPermissionNamesByIds,
  getRoleNameById,
} from "./utils/manage-coaches-utils";
import getAvatarUrl from "../../../../utils/get-avatar-url";

export const ActiveTabCoachComponent = ({
  locals,
  isAdminOrOwner,
  roleName,
}) => {
  const { usersOrganization, organizationRoles = [] } = locals;
  const { organizationActiveUsers = [] } = usersOrganization;
  //state to control the accordion state
  const [accordionState, setAccordionState] = useState({
    coach: "",
    isOpen: false,
  });
  const theme = locals.activeUser.webAppTheme || "dark";

  /**
   * Function to redirect to edit coach modal
   * @param {*} e
   * @param {*} id
   * @param {*} userCanEdit
   */
  const redirectToModal = (e, id, userCanEdit) => {
    if (userCanEdit) {
      e.preventDefault();
      e.stopPropagation();
      submit(`/actions/refresh`, {
        method: "GET",
        body: {
          "modal[type]": "manage-coach-modal",
          coachId: id,
          roleOrganizationName: roleName,
        },
      });
    }
  };

  /**
   * Function to inactive a coach
   * @param {*} e
   * @param {*} coach
   * @param {*} userCanEdit
   */
  const deleteCoach = (e, coach, userCanEdit) => {
    if (userCanEdit) {
      e.stopPropagation();
      e.preventDefault();
      const confirmText =
        coach && !!coach.athletes && coach.athletes.length > 0
          ? "This coach has assigned athletes. Are you sure you want to delete this coach? All assigned athletes will be transferred to the organization's owner"
          : "Are you sure you want to delete this coach?";
      if (process.browser && confirm(confirmText)) {
        submit(`/actions/organizations/remove-user`, {
          method: "POST",
          body: {
            user: coach,
            organizationUserStatus: false,
          },
        });
      }
    }
  };

  return organizationActiveUsers.map((item) => {
    const {
      name = "",
      email = "",
      _id = "",
      organizationPermissions = [],
      organizationRoleId = null,
    } = item;
    const image = getAvatarUrl(
      item,
      null,
      theme,
      theme !== "dark" ? true : false
    );

    const roleNameById = getRoleNameById(organizationRoles, organizationRoleId);
    //check if user is able to edit (admin or owner role)
    const userCanEdit =
      roleName === "Admin"
        ? roleNameById === "Admin" || roleNameById === "Owner"
          ? false
          : true
        : roleName === "Owner"
        ? roleNameById === "Owner"
          ? false
          : true
        : false;

    return (
      <li
        key={_id}
        onClick={() =>
          setAccordionState(
            Object.assign({}, accordionState, {
              coach: _id,
              isOpen: !accordionState.isOpen,
            })
          )
        }
      >
        <article>
          <div className="left">
            <img
              src={image}
              loading="lazy"
              className="profile-picture w-12 h-12 rounded-full"
            />
            <div className="coach-info">
              <p className="s1">{name}</p>
              <p className="p4 opacity-70">{email}</p>
            </div>
          </div>
          <div className="right">
            <span className="subtitle-convert-organization">
              {roleNameById}
            </span>
            {isAdminOrOwner && (
              <button
                role="button"
                data-button-type="outline"
                disabled={userCanEdit ? undefined : true}
                onClick={(e) => {
                  redirectToModal(e, _id, userCanEdit);
                  e.stopPropagation();
                }}
              >
                <span>Edit</span>
              </button>
            )}
            {isAdminOrOwner && (
              <button
                data-button-type="secondary"
                data-action="cancel"
                disabled={userCanEdit ? undefined : true}
                onClick={(e) => {
                  deleteCoach(e, item, userCanEdit);
                }}
              >
                Remove
              </button>
            )}
          </div>
        </article>

        {/* Permissions section */}
        {accordionState.isOpen && accordionState.coach === _id && (
          <div className="permission-details">
            <p className="s3">
              Permissions: {""}
              {`${getPermissionNamesByIds(
                locals.organizationPermissions,
                organizationPermissions
              )}`}
            </p>
          </div>
        )}
      </li>
    );
  });
};
